import capitalize from 'lodash/capitalize';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import { Publish as PublishIcon } from '@vgno/icons';

import {
  formatAssetUpcomingDate,
  getAssetDisplayTitle,
  getAssetMainImage,
} from '../../shared/helpers/assetHelpers';
import type { ButtonProps } from '../Button/Button';
import { Button } from '../Button/Button';
import { Splash } from '../Splash/Splash/Splash';

import * as styles from './UpcomingAssetSplash.module.scss';

type Props = {
  asset: SvpAssetAdditional;
  size: ButtonProps['size'];
};

function UpcomingAssetSplash({ asset, size }: Props) {
  const { description } = asset;

  const imageUrl = getAssetMainImage(asset);
  let subtitle;
  if (asset.series) {
    subtitle = asset.category.title;
  }

  return (
    <div className={styles.container}>
      <Splash
        imageUrl={imageUrl}
        title={getAssetDisplayTitle(asset)}
        subtitle={subtitle}
        description={description}
        lazy={false}
        buttons={
          <Button
            size={size}
            variant="contained"
            rounded
            disabled
            data-testid="upcoming-button"
          >
            <PublishIcon /> {capitalize(formatAssetUpcomingDate(asset))}
          </Button>
        }
      />
    </div>
  );
}

export { UpcomingAssetSplash };
